"use strict";
/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWide = exports.useDesktop = exports.useTablet = exports.usePhone = void 0;
const constants_1 = require("./constants");
const useMediaQuery_1 = require("./useMediaQuery");
const usePhone = (options) => (0, useMediaQuery_1.useMediaQuery)(constants_1.Breakpoint.PHONE, options);
exports.usePhone = usePhone;
const useTablet = (options) => (0, useMediaQuery_1.useMediaQuery)(constants_1.Breakpoint.TABLET, options);
exports.useTablet = useTablet;
const useDesktop = (options) => (0, useMediaQuery_1.useMediaQuery)(constants_1.Breakpoint.DESKTOP, options);
exports.useDesktop = useDesktop;
const useWide = (options) => (0, useMediaQuery_1.useMediaQuery)(constants_1.Breakpoint.WIDE, options);
exports.useWide = useWide;
//# sourceMappingURL=hooks.js.map